import React, { useRef, useState } from 'react';
import { Chip, Popper, Fade } from '@material-ui/core';
import { BaseSelect } from './BaseSelect';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    popper: {
        zIndex: 1500,
    },
    root: {
        position: 'relative',
        display: 'inline-block',
    },
    chipLabel: {
        whiteSpace: 'initial',
    },
    chipRoot: {
        minHeight: 32,
        height: 'auto',
    },
}));

const CompanyFilter = ({
    onChange = () => {},
    onClick = () => {},
    onClose = () => {},
    companies = [],
    selected = [],
    open = false,
}) => {
    const classes = useStyles();
    const anchorRef = useRef(null);
    const [opened, setOpened] = useState(open);

    const sortedCompanies = [...companies].sort((a, b) => {
        if (a.business_name.toLowerCase() < b.business_name.toLowerCase()) {
            return -1;
        }
        if (a.business_name.toLowerCase() > b.business_name.toLowerCase()) {
            return 1;
        }
        return 0;
    });

    const handleToggle = () => {
        setOpened(prevOpen => !prevOpen);
        onClick();
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpened(false);
        onClose();
    };

    const handleChangeType = (event, selectedCompanies, isAllSelected) => {
        onChange(selectedCompanies, isAllSelected);
    };

    const title =
        selected.length === companies.length || selected.length === 0
            ? 'All'
            : selected.map(item => item.business_name).join(', ');

    return (
        <div className={classes.root}>
            <Chip
                ref={anchorRef}
                label={`Company: ${title}`}
                color="secondary"
                onClick={handleToggle}
                style={{ marginRight: 5 }}
                classes={{
                    label: classes.chipLabel,
                    root: classes.chipRoot,
                }}
            />
            <Popper
                open={opened}
                anchorEl={() => anchorRef.current}
                transition
                placement="bottom-end"
                className={classes.popper}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <BaseSelect
                            withCheckbox
                            selectAllOption
                            valueKey="uuid"
                            labelKey="business_name"
                            onClose={handleClose}
                            onChange={handleChangeType}
                            options={sortedCompanies}
                            selected={selected.map(item => item.uuid)}
                        />
                    </Fade>
                )}
            </Popper>
        </div>
    );
};

export { CompanyFilter };
